import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { WhatYouCanDo } from './components/WhatYouCanDo';
import { HowItWorks } from './components/HowItWorks';
import { WhyEscuchaYA } from './components/WhyEscuchaYA';
import { ProblemVisuals } from './components/ProblemVisuals';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingMobileCta } from './components/FloatingMobileCta';
export function App() {
  return <div className="w-full bg-[#1B2B4A] font-body text-white" data-id="element-0">
      <main className="pb-16 sm:pb-0" data-id="element-1">
        <Hero data-id="element-2" />
        <Problem data-id="element-3" />
        <WhatYouCanDo data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <WhyEscuchaYA data-id="element-6" />
        <ProblemVisuals data-id="element-7" />
        <Faq data-id="element-8" />
        <FinalCta data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
      <FloatingMobileCta data-id="element-11" />
    </div>;
}